import { render, staticRenderFns } from "./Unsupportedpage.vue?vue&type=template&id=3b3dc273&"
import script from "./Unsupportedpage.vue?vue&type=script&lang=js&"
export * from "./Unsupportedpage.vue?vue&type=script&lang=js&"
import style0 from "./Unsupportedpage.vue?vue&type=style&index=0&id=3b3dc273&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports